// @flow

import * as React from 'react';
import ViewMoreList from '@active/awe-ui-core/lib/components/ViewMoreList';

const { PureComponent } = React;

type Props = {
  loading: boolean,
  total: number,
  length: number,
  keyword: string,
  applicationName: string,
  label: string,
  children: React.Node,
  handleViewMore: () => void,
  onViewMore: (
    length: number,
    keyword: string,
    applicationName: string) => void
}

export default class ViewMore extends PureComponent<Props> {
  handleViewMore = () => {
    this.props.onViewMore(this.props.length, this.props.keyword, this.props.applicationName);
  }

  render() {
    const {
      children, length, total, loading, label,
    } = this.props;

    return (
      <div>
        <ViewMoreList
          length={length}
          total={total}
          loading={loading}
          moreButtonText={label}
          onViewMore={this.handleViewMore} >
          {children}
        </ViewMoreList>
      </div>
    );
  }
}
